import { Button, Form, Input, Modal, Switch } from 'antd';
import { useEffect, useState } from 'react';
import { SoftwareSetting } from '../../../Models/SoftwareManager/SoftwareSettings';
import { NdServiceSetting } from '../../../Models/SoftwareManager/NdServiceSetting';
import { v4 as uuidv4 } from 'uuid';

export function AddNdServiceConfig(props: {
  allData?: NdServiceSetting[];
  parentData?: SoftwareSetting;
  data?: NdServiceSetting;
  open: boolean;
  onCancel: Function;
  onSafe: Function;
  onRemove: Function;
  onEdit: boolean;
}) {
  const [form] = Form.useForm();

  const [removeItem, setRemoveItem] = useState(false);
  const [setting, setSetting] = useState<NdServiceSetting>();

  const messageValidation = 'Vul a.u.b. dit veld in';

  useEffect(() => {
    form.resetFields();
    setSetting(props.data);
    setRemoveItem(false);
  }, [form, props.parentData, props.data, setting]);

  const handleCancel = () => {
    props.onCancel();
  };

  const onFinishForm = (data: NdServiceSetting) => {
    if (props.data?.id !== undefined) {
      data.id = props.data?.id;
    }

    var setting = props.parentData;
    if (setting === undefined) {
      return;
    }

    if (removeItem) {
      var indexForRemove = setting.ndServiceSettings.findIndex(
        (x) => x.serviceLabel === data.serviceLabel,
      );
      setting.ndServiceSettings.splice(indexForRemove, 1);
      props.onRemove(setting);
    } else {
      if (!props.onEdit) {
        //add
        if (setting.ndServiceSettings === null) {
          setting.ndServiceSettings = [data];
        } else {
          if (setting.ndServiceSettings == null) {
            setting.ndServiceSettings = [data];
          } else {
            let myuuid = uuidv4();
            data.id = myuuid;
            setting.ndServiceSettings.push(data);
          }
        }
      } else {
        //edit
        var index = setting.ndServiceSettings.findIndex(
          (x) => x.id === data.id,
        );
        if (data.startAtStartUp == undefined) {
          data.startAtStartUp = false;
        }

        setting.ndServiceSettings[index] = data;
      }
      props.onSafe(setting);
    }
  };

  const onFinishFormFailed = (errorInfo: any) => {};

  const checkPrice = (_: any, value: string) => {
    var foundItem = props.allData?.find((x) => x.serviceLabel === value);

    if (foundItem !== undefined) {
      if (foundItem.serviceLabel === props.data?.serviceLabel) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Dit label bestaat al'));
    }
    return Promise.resolve();
  };

  return (
    <Modal
      title="Voeg een node service configuratie toe"
      open={props.open}
      onOk={() => form.submit()}
      okText="Opslaan"
      cancelText="Annuleren"
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Annuleer
        </Button>,

        <Button
          key="link"
          type="primary"
          onClick={() => {
            setRemoveItem(true);
            form.submit();
          }}
        >
          Verwijder
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          Opslaan
        </Button>,
      ]}
    >
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600, height: 'auto' }}
        initialValues={props.data}
        onFinish={onFinishForm}
        onFinishFailed={onFinishFormFailed}
        autoComplete="off"
        form={form}
      >
        <Form.Item
          label="Label"
          name="serviceLabel"
          rules={[
            {
              required: true,
              message: messageValidation,
            },
            { validator: checkPrice },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Beschrijving" name="description">
          <Input />
        </Form.Item>
        <Form.Item
          label="Online source (url)"
          name="sourceRemote"
          key="sourceRemote"
          rules={[{ required: true, message: messageValidation }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Lokaal source (map)"
          name="sourceLocal"
          key="sourceLocal"
          rules={[{ required: true, message: messageValidation }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Build map"
          name="buildDirectory"
          key="buildDirectory"
          rules={[{ required: true, message: messageValidation }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Service naam"
          name="serviceName"
          key="serviceName"
          rules={[{ required: true, message: messageValidation }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Service map"
          name="serviceDirectory"
          key="serviceDirectory"
          rules={[{ required: true, message: messageValidation }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Starten bij opstarten"
          name="startAtStartUp"
          key="startAtStartUp"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
}
